import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, FormControl, Validators } from "@angular/forms";
import { ToastClientService } from "../../../services/toast/toast-client.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})

export class BannerComponent implements OnInit {
  addOrEditBanner: string;
  bannerForm;
  tempOptionModel;
  tempOptionModel1;
  sendFormData: any;
  bannerSingleInfo: any;
  banners = [];
  roles = [];
  modules = [];
  languages = [];
  regions = [];
  states = [];
  cities = [];
  userlevel = [];
  role_id = '';
  module_id = '';
  regionSettings = {};
  moduleSettings = {};
  stateSettings = {};
  citySettings = {};
  userLevelettings = {};
  selectedModules = [];
  selectedRegions = [];
  selectedStates = [];
  selectedCities = [];
  selectedUserLevel = [];
  banner_id: any;
  language_id = '';
  banner_name: any;
  banner_image: any;
  img: any;
  banner_image_path: any;
  banner_image_order: any;
  today: any;
  startDate: any;
  endDate: any;
  isReadOnly1 = false;
  isReadOnly2 = true;
  userFile: any = '';
  sendFile: any = '';
  showFileName: any = '';
  showFileName1: any = '';
  isDisable2: boolean = false;
  bannerHeadersList: any;
  zip_file_name: any = '';
  zip_file: any = '';
  statusCount: any = [];
  statusCount1: any = [];
  hideOrders: boolean = true;
  hideOrders1: boolean = true;
  RejectArray: any = [];
  exlDownLoadUrl2: any;
  exlDownLoadUrl3: any;
  UserLevelRes: any = [];
  userRejected: any = [];
  success_UserId: any = [];

  userDropFlag: boolean = false;
  userExcelFlag: boolean = false;
  userExcelFile: any = '';


  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    public exportExcelService: ExportExcelService,
  ) {
    this.today = new Date().toISOString().slice(0, 16);
  }

  ngOnInit() {
    this.getBanners();
    this.getAppUserRoles();
    this.getAllRegions();
    this.getAllModules();
    this.getLanguages();
    this.getExcelBannerFields();
    this.validateForm();
  }

  getBanners() {
    this.apiService.get(this.apiConfig.configGetBanners).subscribe(
      (res: any) => {
        this.banners = res.data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getLanguages() {
    this.apiService.get(this.apiConfig.configGetLanguages).subscribe(
      (res: any) => {
        this.languages = res.data;
      },
      (err) => {
        //console.log(err);
      }
    );
  }


  getAppUserRoles() {
    this.apiService.get(this.apiConfig.configGetAppUserRoles).subscribe(
      (res: any) => {
        this.roles = res.data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getAllRegions() {
    this.apiService.get(this.apiConfig.dropRegionName+`?program_id=1&region_id=`).subscribe(
      (res: any) => {
        this.regions = res.data.region;
        this.regionSettings = {
          singleSelection: false,
          idField: 'id',
          textField: 'region_name',
          enableCheckAll: true,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: true,
          limitSelection: -1,
          clearSearchFilter: true,
          maxHeight: 197,
          itemsShowLimit: 3,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Data Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false,
        };
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getExcelBannerFields() {
    this.apiService.get(this.apiConfig.bannersExcelHeaders)
      .subscribe((res: any) => {
        if (res.status == 200) {
          let headers = Object.keys(res.data.banners);
          console.log(headers)
          this.bannerHeadersList = headers;
        }
      }, err => {
        console.log(err);
      })
  }

  getAllModules() {
    this.apiService.get(this.apiConfig.configGetAllModules + "?role_id=" + this.role_id).subscribe(
      (res: any) => {
        this.modules = res.data;
        this.moduleSettings = {
          singleSelection: false,
          idField: 'id',
          textField: 'module_name',
          enableCheckAll: true,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: true,
          limitSelection: -1,
          clearSearchFilter: true,
          maxHeight: 197,
          itemsShowLimit: 3,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Data Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false,
        };
      },
      (err) => {
        console.log(err);
      }
    );
  }

  parseStartDate(dateString: string) {
    if (dateString) {
      this.startDate = dateString;
      this.isReadOnly2 = false;
    }
  }

  parseEndDate(dateString: string) {
    if (dateString) {
      this.endDate = dateString;
    }
  }

  //Module Selection
  public onModuleSelect(item: any) {
    this.selectedModules.push(item);
    this.selectedModules.splice(-1);
  }

  public onModuleDeSelect(item: any) {
    let index = this.selectedModules.findIndex(function (data) {
      return data.id == item.id
    });
    if (index !== -1) {
      this.selectedModules.splice(index, 1);
    }
  }

  public onModuleSelectAll(items: any) {
    this.selectedModules = items;
  }

  public onModuleDeSelectAll(items: any) {
    this.selectedModules = [];
  }

  //Region Selection
  public onRegionSelect(item: any) {
    this.selectedRegions.push(item);
    this.selectedRegions.splice(-1);
    this.filteredState();
  }

  public onRegionDeSelect(item: any) {
    let index = this.selectedRegions.findIndex(function (data) {
      return data.id == item.id
    });
    if (index !== -1) {
      this.selectedRegions.splice(index, 1);
    }
    this.filteredState();
  }

  public onRegionSelectAll(items: any) {
    this.selectedRegions = items;
    this.filteredState();
  }

  public onRegionDeSelectAll(items: any) {
    this.selectedRegions = [];
    this.states = [];
    this.selectedStates = [];
    this.cities = [];
    this.selectedCities = [];
  }

  //State Selection
  public onStateSelect(item: any) {
    this.selectedStates.push(item);
    this.selectedStates.splice(-1);
    this.filteredCity();
    this.getUserLevelList();
  }

  public onStateDeSelect(item: any) {
    let index = this.selectedStates.findIndex(function (data) {
      return data.state_code == item.state_code
    });
    console.log(index);
    if (index !== -1) {
      this.selectedStates.splice(index, 1);
    }
    // this.filteredCity();
    this.getUserLevelList();
  }

  public onStateSelectAll(items: any) {
    this.selectedStates = items;
    // this.filteredCity();
    this.getUserLevelList();
  }

  public onStateDeSelectAll(items: any) {
    this.selectedStates = [];
    this.cities = [];
    this.selectedCities = [];
    this.getUserLevelList();
  }

  //City Selection
  public onCitySelect(item: any) {
    this.selectedCities.push(item);
    this.selectedCities.splice(-1);
    this.getUserLevelList();
  }

  public onCityDeSelect(item: any) {
    let index = this.selectedCities.findIndex(function (data) {
      return data.id == item.id
    });
    console.log(index);
    if (index !== -1) {
      this.selectedCities.splice(index, 1);
    }
    this.getUserLevelList();
  }

  public onCitySelectAll(items: any) {
    this.selectedCities = items;
    this.getUserLevelList();
  }

  public onCityDeSelectAll(items: any) {
    this.selectedCities = [];
    this.getUserLevelList();
  }

  //User Level Selection
  public onUserLevelSelect(item: any) {
    this.selectedUserLevel.push(item);
    this.selectedUserLevel.splice(-1);
    this.userFile = "";
    this.showFileName1 = "";

    this.showFileName = "";
    this.userFile = "";
    if (this.selectedUserLevel.length > 0) {
      this.userExcelFlag = true;
    }


  }

  public onUserLevelDeSelect(item: any) {
    let index = this.selectedUserLevel.findIndex(function (data) {
      return data.user_id == item.user_id
    });
    console.log(index);
    if (index !== -1) {
      this.selectedUserLevel.splice(index, 1);
    }
    this.userFile = "";
    this.showFileName1 = "";
    this.getUserLevelList();
  }

  public onUserLevelSelectAll(items: any) {
    this.selectedUserLevel = items;
    this.userFile = "";
    this.showFileName1 = "";
    this.showFileName = "";
    this.userFile = "";
    if (this.selectedUserLevel.length > 0) {
      this.userExcelFlag = true;
    }
  }

  public onUserLevelDeSelectAll(items: any) {
    this.selectedUserLevel = [];
    this.userFile = "";
    this.showFileName1 = "";
    this.userDropFlag = false;
    this.userExcelFlag = false;

  }

  filteredState() {
    let reg = this.selectedRegions.map((i) => i.id).join(",");
    let payload = {
      regions: reg
    }
    this.states = [];
    this.selectedStates = [];
    this.cities = [];
    this.selectedCities = [];
    this.apiService.get(this.apiConfig.configFilteredState+`?state_id=&region_id=${reg}`).subscribe(
      (res: any) => {
        console.log(res.data)
        this.states = res.data.state;
        this.stateSettings = {
          singleSelection: false,
          idField: 'state_code',
          textField: 'state_name',
          enableCheckAll: true,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: true,
          limitSelection: -1,
          clearSearchFilter: true,
          maxHeight: 197,
          itemsShowLimit: 3,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Data Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false,
        };
      },
      (err) => {
        console.log(err);
      }
    );
  }

  filteredCity() {
    let stat = this.selectedStates.map((i) => i.state_code).join(",");
    let payload = {
      states: stat
    }
    this.cities = [];
    this.selectedCities = [];
    this.apiService.post(this.apiConfig.configFilteredCity, payload).subscribe(
      (res: any) => {
        this.cities = res.body.data;
        this.citySettings = {
          singleSelection: false,
          idField: 'id',
          textField: 'cityname',
          enableCheckAll: true,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: true,
          limitSelection: -1,
          clearSearchFilter: true,
          maxHeight: 197,
          itemsShowLimit: 3,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Data Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false,
        };
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  getUserLevelList() {
    this.apiService.get(this.apiConfig.configGetUserLevel + "?region_ids=" + this.selectedRegions.map((i) => i.id).join(",") + "&state_id=" + this.selectedStates.map((i) => i.state_code).join(",") ).subscribe(
      (res: any) => {
        this.userlevel = res.data;
        this.userLevelettings = {
          singleSelection: false,
          idField: 'user_id',
          textField: 'full_name',
          enableCheckAll: true,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: true,
          limitSelection: -1,
          clearSearchFilter: true,
          maxHeight: 197,
          itemsShowLimit: 3,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Data Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false,
        };
      },
      (err) => {
        //console.log(err);
      }
    );
  }

  uploadClick1() {
    document.getElementById('upload-input-1').click();
  }

  uploadClick2() {
    document.getElementById('upload-input-2').click();
  }

  uploadClick3() {
    document.getElementById('upload-input-3').click();
  }

  imageChange(img) {
    var parentArea = this;
    var _URL = window.URL;
    let allImages: Array<string> = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/x-png', 'image/tiff', 'image/bpg'];
    var file = img.target.files[0];
    if ((file = img.target.files[0])) {
      img = new Image();
      img.src = _URL.createObjectURL(file);
      img.onload = function () {
        window.URL.revokeObjectURL(img.src);
        parentArea.someCallback(this.width, this.height);
      };
    }

    if (allImages.indexOf(file.type) === -1) {
      this.bannerForm.controls["banner_image"].patchValue();
      this.toast.Error("Image Type is not Correct !")
      return;
    } else {
      var reader = new FileReader();
      var self = this;
      reader.onload = (e) => {
        this.img = reader.result;
        this.banner_image = reader.result;
      }
      reader.readAsDataURL(file);
    }

  }

  someCallback(width, height) {
    if (width != 800 && height != 800) {
      this.bannerForm.controls["banner_image"].patchValue();
      this.toast.Error("Banner should be 600 x 280 size !")
      return;
    }
  }

  addBanner(targetModal, data) {
    this.isReadOnly1 = false;
    this.isReadOnly2 = true;
    // this.getAppUserRoles();
    this.getAllRegions();
    this.getAllModules();
    this.addOrEditBanner = "add";
    this.showBannerModal(targetModal);
    this.userDropFlag = false;
    this.userExcelFlag = false;
  }

  validateForm() {
    this.bannerForm = this.fb.group({
      banner_name: ['', Validators.compose([Validators.required,])],
      banner_image_order: ['', Validators.compose([Validators.required,
      Validators.pattern("^[0-9]*$")])],
      module_id: ['', Validators.compose([Validators.required,])],
      language_id: ['', Validators.compose([Validators.required,])],
      level_id: [''],
      region_id: ['', Validators.compose([Validators.required,])],
      state_id: ['', Validators.compose([Validators.required,])],
      // city_id: ['', Validators.compose([Validators.required,])],
      start_date: ['', Validators.compose([Validators.required,])],
      end_date: ['', Validators.compose([Validators.required,])],
      banner_image: ['', Validators.compose([Validators.required,])]
    })
  }

  get f() {
    return this.bannerForm.controls;
  }

  editbanner(targetModal, bannerInfo) {
    this.isReadOnly1 = true;
    this.isReadOnly2 = false;
    this.bannerForm.get('banner_image').setValidators([]);
    this.bannerForm.get('banner_image').updateValueAndValidity();
    this.getAppUserRoles();
    this.getAllRegions();
    this.getAllModules();
    this.banner_id = bannerInfo.id;
    this.language_id = bannerInfo.language_id;
    this.banner_name = bannerInfo.banner_name;
    this.banner_image_order = bannerInfo.banner_image_order;
    this.banner_image_path = bannerInfo.banner_image_path;
    this.img = bannerInfo.banner_image_path;
    this.getAllModules();
    this.selectedModules = bannerInfo.modules;
    this.selectedRegions = bannerInfo.region;
    this.selectedUserLevel = bannerInfo.levels;
    this.userDropFlag = false;
    this.filteredState();
    this.selectedStates = bannerInfo.state;
    // this.filteredCity();
    this.selectedCities = bannerInfo.city;
    this.startDate = bannerInfo.start_date;
    this.endDate = bannerInfo.end_date;
    this.addOrEditBanner = "edit";
    this.getUserLevelList();
    setTimeout(() => {
      this.showBannerModal(targetModal);
    }, 2000);
  }


  status_Change(bannerInfo) {
    let payload = {
      id: bannerInfo.id,
      status: (bannerInfo.status == false) ? 0 : 1
    }
    this.apiService.post(this.apiConfig.configDeleteBanner, payload).subscribe(
      (res: any) => {
        this.getBanners();
        this.toast.Success(res.body.data);
      },
      (err) => {
        this.getBanners();
      }
    );
  }

  showBannerModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: 'lg',
    });
  }

  submitted = false;

  onSubmitBanner(formData, targetModal) {
    this.submitted = true;
    if (this.addOrEditBanner == "add") {
      if (this.banners.filter(e => e.banner_image_order == this.bannerForm.value.banner_image_order).length > 0) {
        this.toast.Error("The Sequence already exists");
        return;
      }
    }
    if (this.addOrEditBanner == "edit") {
      var newBanners = this.banners.filter(e => e.id != this.banner_id);
      console.log(newBanners);
      if (newBanners.filter(e => e.banner_image_order == this.bannerForm.value.banner_image_order).length > 0) {
        this.toast.Error("The Sequence already exists");
        return;
      }
    }
    if (this.bannerForm.invalid) {
      this.bannerForm.markAllAsTouched();
      return;
    } else {
      this.showModalPopUp(targetModal);
      this.sendFormData = formData;
    }
  }


  showModalPopUp(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "sm"
    });
  }



  submitYes() {
    const formData = new FormData();
    formData.append('program_id', '1');
    formData.append('banner_name', this.bannerForm.value.banner_name);
    formData.append('banner_image_order', this.bannerForm.value.banner_image_order);
    formData.append('module_id', this.selectedModules.map((i) => i.id).join(","));
    formData.append('language_id', this.bannerForm.value.language_id);
    formData.append('level_id', this.selectedUserLevel.map((i) => i.user_id).join(","));
    formData.append('region_id', this.selectedRegions.map((i) => i.id).join(","));
    formData.append('state_id', this.selectedStates.map((i) => i.state_code).join(","));
    // formData.append('city_id', this.selectedCities.map((i) => i.id).join(","));
    formData.append('start_date', this.bannerForm.value.start_date);
    formData.append('end_date', this.bannerForm.value.end_date);
    if (this.banner_image) {
      formData.append('banner_image', this.banner_image);
    }
    //formData.append('userFile', this.userFile);
    formData.append('succes_users', (this.success_UserId.toString()));
    let apiUrl;
    if (this.addOrEditBanner == 'add') {
      apiUrl = this.apiConfig.configAddBanner;
      delete this.img;
    } else if (this.addOrEditBanner == 'edit') {
      formData.append('id', this.banner_id);
      apiUrl = this.apiConfig.configEditBanner;
      delete this.img;
    }
    this.apiService.upload_with_loader(apiUrl, formData)
      .subscribe((res: any) => {
        try {
          this.toast.Success(res.body.data.message);
          this.getBanners();
          this.userFile = "";
          this.showFileName1 = "";
          this.getAppUserRoles();
          this.getAllRegions();
          this.getAllModules();
          this.submitted = false;
          this.modalService.dismissAll();
        }
        catch (a) {
        }
      }, (err) => {
        this.toast.Error("Failed to Update");
        console.log(err);
      });
    this.submitted = false;
  }

  viewBanner(targetModal, singleInfo) {
    this.bannerSingleInfo = singleInfo;
    setTimeout(() => {
      this.showRoleModal(targetModal, 'lg');
    })

  }

  showRoleModal(targetModal, size) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: size
    });
  }


  dodnloadUserTemplate() {
    let excelName = "User_"
    let headers = ["Valvoline User ID", "Mobile Number",]
    this.exportExcelService.commonPrintHeaders(headers, excelName)

  }


  uploadUserFile() {
    document.getElementById('upload-input').click();
  }

  uploadXlsx(event: any) {
    let fileName;
    let size;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      fileName = file.name;
      this.showFileName = fileName;
      this.isDisable2 = false;
      size = (file.size / 1024 / 1024).toFixed(2) + ' MB';
      this.sendFile = file;
      //this.importBulkExcel(file);

    } else {
      this.toast.Error("File has not imported!");
      return
    }
  }

  uploadUserXlsx(event: any, targetModal) {
    let fileName;
    let size;
    if (event.target.files.length > 0) {
      this.selectedUserLevel = [];
      const file = event.target.files[0];
      this.userExcelFile = event.target.files[0];
      fileName = file.name;
      this.showFileName1 = fileName;
      size = (file.size / 1024 / 1024).toFixed(2) + ' MB';
      this.userFile = file;
      //this.importBulkExcel(file);
      if (this.userExcelFile) {
        this.userDropFlag = true;
      }


      let apiUrl = this.apiConfig.uploadUserExcel_banner;
      const formData = new FormData();
      formData.append('upload', this.userFile);
      this.apiService.upload1(apiUrl, formData)
        .subscribe((res: any) => {
          try {
            this.UserLevelRes = res.body.data;
            this.userRejected = this.UserLevelRes.rejected;
            this.submitted = false;
            if (this.UserLevelRes.import_count) {
              this.hideOrders1 = false;
              this.RejectedDataModal1(targetModal);
            }
            this.exlDownLoadUrl2 = this.UserLevelRes.rejection_link;
            this.success_UserId  = this.UserLevelRes.approved_ids;
          }
          catch (a) {
          }
        },
          (err) => {
            this.toast.Error("Failed to Update");
            this.dismissSmallModal();
          }
        );


    } else {
      this.toast.Error("File has not imported!");
      return
    }
  }

  uploadZip(event: any) {
    let file = event.target.files[0];
    this.zip_file_name = file.name;
    this.zip_file = file;
  }

  downloadFile() {
    this.exportExcelService.exportBannerExcel(this.bannerHeadersList);
  }

  bulkFOCUpload(targetModal, size) {
    this.showModal(targetModal, size);
    if (this.showFileName) {
      this.isDisable2 = false;
    } else {
      this.isDisable2 = true;
    }
  }

  showModal(targetModal, size) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: size
    });
  }

  importBulkExcel(tempOptionModel) {
    this.showModalPopUp(tempOptionModel);
  }


  submitYesExcel() {
    const formData = new FormData();
    formData.append('banners', this.sendFile);
    formData.append('zip_file', this.zip_file);

    if (this.zip_file && this.zip_file) {
      this.apiService.upload_with_loader(this.apiConfig.uploadBannerExcel, formData)
        .subscribe((res: any) => {
          try {
            this.RejectArray = [];
            this.statusCount = res.body.data;
            this.exlDownLoadUrl3 = this.statusCount.rejection_link;
            this.toast.Success(res.body.data.message);
            this.getBanners();
            this.modalService.dismissAll();
            this.hideOrders = false;
            this.sendFile = "";
            this.zip_file = "";
            this.showFileName = "";
            this.zip_file_name = "";
            if (this.statusCount.rejected_data) {
              this.statusCount.rejected_data.forEach(element => {
                this.RejectArray.push(element)
              });
            }
          } catch {

          }
        },
          (err) => {
            this.toast.Error("Failed to Update");
            this.dismissSmallModal();
          }
        );
    } else {
      this.toast.Error("Please upload the zip file");
    }
  }

  RejectedDataModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: 'lg'
    });
  }

  RejectedDataModal1(targetModal) {
    this.submitted = false;
    this.tempOptionModel1 = this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: 'lg'
    });
  }



  contunueWithCurrentUser() {
    this.tempOptionModel1.close();
    this.submitted = false;
  }



  dismissSmallModal() {
    this.tempOptionModel.close();
    this.submitted = false;
  }

  dismissSmallModal1() {
    this.showFileName1= '';
    this.tempOptionModel1.close();
    this.submitted = false;
  }

  dismissModal() {
    this.submitted = false;
    this.modalService.dismissAll();
    this.banner_name = "";
    this.banner_image = "";
    this.img = "";
    this.banner_image_order = "";
    this.banner_image_path = "";
    this.role_id = "";
    this.modules = [];
    this.module_id = "";
    this.language_id = "";
    this.selectedRegions = [];
    this.states = [];
    this.selectedStates = [];
    this.cities = [];
    this.selectedCities = [];
    this.selectedUserLevel = [];
    this.selectedModules = [];
    this.startDate = "";
    this.endDate = "";
    this.userFile = "";
    this.showFileName1 = "";
    this.zip_file_name = "";
    this.sendFile = "";
    this.zip_file = "";
    this.showFileName = "";
    this.bannerForm.reset();
    this.userDropFlag = false;
    this.userExcelFlag = false;
    this.showFileName = "";
  }


  download2() {
    if (this.exlDownLoadUrl2 != '') {
      setTimeout(() => {
        document.getElementById("downloadLink2").click();
      }, 1000);
      return;
    }
  }

  download3() {
    if (this.exlDownLoadUrl3 != '') {
      setTimeout(() => {
        document.getElementById("downloadLink3").click();
      }, 1000);
      return;
    }
  }

  clearFile() {
    this.showFileName1 = "";
    this.userFile = "";
    this.success_UserId = [];
    this.userDropFlag = false;
    this.userExcelFlag = false;
  }


}
